import React from "react";
import {
  WorkShell,
  WorkSideRail,
  WorkRailPoster,
  WorkMain,
  WorkHero,
  WorkHeroEyebrow,
  WorkHeroTitle,
  WorkHeroLead,
  WorkContentContainer,
} from "./styles";

export type WorkProjectShellProps = {
  posterSrc: string;
  title: string;
  lead: React.ReactNode;
  eyebrow?: string;
  children: React.ReactNode;
  /**
   * When true, the poster rail is fixed under the header and only the main
   * column scrolls.
   */
  splitScroll?: boolean;
  /** `editorial` = gradient rail + full-height cover poster (default for case studies). */
  railVariant?: "default" | "editorial";
};

export function WorkProjectShell({
  posterSrc,
  title,
  lead,
  eyebrow = "Case study",
  children,
  splitScroll = true,
  railVariant = "editorial",
}: WorkProjectShellProps) {
  return (
    <WorkShell $splitScroll={splitScroll}>
      <WorkSideRail $splitScroll={splitScroll} $railVariant={railVariant}>
        <WorkRailPoster $variant={railVariant}>
          <img src={posterSrc} alt="" />
        </WorkRailPoster>
      </WorkSideRail>
      <WorkMain $splitScroll={splitScroll}>
        <WorkHero>
          <WorkHeroEyebrow>{eyebrow}</WorkHeroEyebrow>
          <WorkHeroTitle>{title}</WorkHeroTitle>
          <WorkHeroLead>{lead}</WorkHeroLead>
        </WorkHero>
        <WorkContentContainer>{children}</WorkContentContainer>
      </WorkMain>
    </WorkShell>
  );
}
